import { css } from "../../../styled-system/css";
import { Flex } from "../../../styled-system/jsx";
import { Button } from "components/core/basic/Button";
import { AdvertisementCell } from "modules/advertising/tableCells/AdvertisementCell";
import { useReactTable, getCoreRowModel, getPaginationRowModel, createColumnHelper } from "@tanstack/react-table";
import { Table } from "components/table/Table";
import { RT8Pagination } from "components/table/Pagination";
import { type GVAdvertisement } from "modules/advertising/types";
import { Modal } from "components/core/basic/RACModal";

type BulkActionFeedback = {
  failedEntities?: GVAdvertisement[];
  resultMessages?: string[];
};

type Props = {
  bulkActionFeedback?: BulkActionFeedback;
  clearBulkActionFeedback: () => void;
  setSelected: (value: number[]) => void;
  showBulkActionFeedbackModal: boolean;
};

const columnHelper = createColumnHelper<GVAdvertisement>();

const columns = [
  columnHelper.accessor("ad_name", {
    header: "",
    enableHiding: false,
    enableSorting: false,
    cell: (props) => {
      return (
        <AdvertisementCell ad={props.row.original} className={css({ marginRight: "auto", overflowX: "hidden" })} />
      );
    },
    size: 550,
  }),
];

const BulkActionFeedbackModal = ({
  showBulkActionFeedbackModal,
  bulkActionFeedback,
  setSelected,
  clearBulkActionFeedback,
}: Props) => {
  const failedEntityIds = bulkActionFeedback?.failedEntities?.map((entity) => entity.ad_id);

  const table = useReactTable({
    data: bulkActionFeedback?.failedEntities ?? [],
    columns,
    defaultColumn: {
      filterFn: () => true,
    },
    enableRowSelection: false,
    getCoreRowModel: getCoreRowModel(),
    rowCount: bulkActionFeedback?.failedEntities?.length || 0,
    getPaginationRowModel: getPaginationRowModel(),
    initialState: {
      pagination: {
        pageSize: 5,
      },
    },
  });

  return (
    <Modal
      title={`Bulk Action Results`}
      isOpen={showBulkActionFeedbackModal}
      onOpenChange={() => clearBulkActionFeedback()}
      className={css({ width: "60vw" })}
    >
      {bulkActionFeedback?.resultMessages?.map((message, i) => {
        return (
          <p className={css({ padding: "xsmall", textAlign: "center" })} key={i}>
            {message}
          </p>
        );
      })}
      {bulkActionFeedback?.failedEntities?.length ?
        <div className={css({ width: "600px", margin: "auto" })}>
          <Flex justifyContent={"flex-end"}>
            <RT8Pagination className={css({ marginLeft: "auto" })} table={table} canSetPageSize={false} />
          </Flex>
          <Table table={table} />
        </div>
      : null}

      <Flex className={css({ paddingTop: "large" })} gap={"xlarge"} justifyContent={"center"}>
        {failedEntityIds?.length ?
          <Button
            onPress={() => {
              setSelected(failedEntityIds);
              clearBulkActionFeedback();
            }}
          >
            Retry Updates
          </Button>
        : null}
        <Button
          onPress={() => {
            clearBulkActionFeedback();
          }}
        >
          Continue
        </Button>
      </Flex>
    </Modal>
  );
};

export default BulkActionFeedbackModal;
